import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useFormik } from 'formik';
import { useAuth } from '../context/AuthContext';
import server from '../global/server';
import useHandleErrors from '../hooks/useHandleErrors';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import { noAutoFormat } from "../global/helpers";
import { useAutofillSync } from '../hooks/useAutofillSync';

export default (props)=>{

    const { Login, logged} = useAuth();
    const navigation = useNavigate()

    const [hasError, setError] = useState();
    useHandleErrors(hasError);

    const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting } = useFormik({
        initialValues: { username: '', password: '' },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.get('auth/firstUser');
                const { data } = await server.post('auth/backoffice', values);
                Login(data.data, '/backoffice')

                // Verifica se existe URL salva para redirecionar
                const redirectUrl = sessionStorage.getItem('redirectAfterLogin');

                if (redirectUrl) {
                    // Remove a URL salva do sessionStorage
                    sessionStorage.removeItem('redirectAfterLogin');
                    navigation(redirectUrl);
                } else {
                    navigation('/backoffice')
                }
                setSubmitting(false);

            } catch (error) {
                setSubmitting(false);
                setError(error);
            }
        },
    });

    // O preenchimento automatico do navegador nao dispara onChange: sem isso o
    // formik fica vazio e o botao Entrar, desabilitado
    const formRef = useRef(null);
    useAutofillSync(formRef, ['username', 'password'], (nome, valor) => {
        if (values[nome] !== valor) setFieldValue(nome, valor);
    });

    useEffect( ()=>{
        if(logged){
            // Verifica se existe URL salva para redirecionar
            const redirectUrl = sessionStorage.getItem('redirectAfterLogin');

            if (redirectUrl) {
                sessionStorage.removeItem('redirectAfterLogin');
                navigation(redirectUrl);
            } else {
                navigation('/backoffice')
            }
        }
    },[logged])

    return (
        <PanelAuth>
            <div>
                {/* <Logo>
                    <img width={250} src={logo}sx={{ marginBottom: 20 }} />
                </Logo> */}
                <BoxAuth>
                    <form onSubmit={handleSubmit} ref={formRef}>
                        <Grid container direction="column" gap={2}>
                            <Grid>
                                <Title>
                                    <Typography variant="h6">Acesse o Backoffice</Typography>
                                </Title>
                            </Grid>
                            {/* Sem shrink fixo a label desce por cima do valor
                                preenchido pelo navegador */}
                            <Grid>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    required
                                    label="Usuário"
                                    InputLabelProps={{ shrink: true }}
                                    type="text"
                                    name="username"
                                    inputProps={noAutoFormat}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.username}
                                    //disabled={isOffline}
                                    error={Boolean(errors.username)}
                                    helperText={errors.username}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    label="Senha"
                                    InputLabelProps={{ shrink: true }}
                                    type="password"
                                    name="password"
                                    inputProps={noAutoFormat}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.password}
                                    error={Boolean(errors.password)}
                                    helperText={errors.password}
                                    //disabled={isOffline}
                                />
                            </Grid>

                            <Grid>
                                <LoadingButton
                                    type="submit"
                                    fullWidth
                                    loading={isSubmitting}
                                    variant="contained"
                                    disabled={!(values.username && values.password) || isSubmitting  }
                                >
                                    Entrar
                                </LoadingButton>
                            </Grid>
                            {/* <Grid>
                                <LoadingButton onClick={() => navigation('/criar-conta?sign=encontrado')} fullWidth variant="text" disabled={isSubmitting}>
                                    Criar minha conta
                                </LoadingButton>
                            </Grid> */}
                            {/* 
                            <Grid>
                                <LoadingButton onClick={() => navigation('/profile/register')} fullWidth variant="text" disabled={isSubmitting}>
                                    Criar curriculo
                                </LoadingButton>
                            </Grid> */}
                        </Grid>
                    </form>
                </BoxAuth>
            </div>
        </PanelAuth>
    );
};

const PanelAuth = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #eee;
`;

const BoxAuth = styled(Grid)`
    border: 1px solid #ccc;
    border-radius: 1rem;
    padding: 2rem;
    width: 350px;
    background: white;
`;

const Title = styled.div`
    text-align: center;
    margin-bottom: 20px;
`;

const BoxAuthContainer = styled.div`
    padding: 1px;
`;
